import React from 'react';
import { Typography, Icon, Stack, Grid } from '@nextiva/next-ui-components';
import { ICompanyTypeInfo } from 'interface/WizardV3';
import { CompanyTypeInfo } from './CampaignDialog/constants';

export function CompanyTypeCell({
  companyType,
  isApproved = false,
}: {
  companyType: string;
  isApproved: boolean;
}) {
  return (
    <Grid item xs={isApproved ? 3 : 'auto'} data-testid="CompanyTypeCell">
      <Typography
        variant="body2"
        color="#0B1029"
        fontWeight={800}
        marginBottom="8px"
      >
        Company type:
      </Typography>
      {CompanyTypeInfo.map((companyInfo: ICompanyTypeInfo) => {
        return (
          companyInfo.value === companyType && (
            <Stack
              direction="row"
              alignItems="center"
              gap={1}
              key={companyInfo.value}
            >
              <Icon
                icon={companyInfo.icon}
                size={16}
                sx={{ color: '#A0A2AD' }}
              />
              <Typography variant="body2" color="#0B1029">
                {companyInfo.title}
              </Typography>
            </Stack>
          )
        );
      })}
    </Grid>
  );
}
